<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Mantenimiento Cupones</h5>
                <p class="text-sm mb-0">
                  Gestión de descuentos y reglas de cupones.
                </p>
              </div>
              <div class="ms-auto my-auto mt-lg-0 mt-4">
                <div class="ms-auto my-auto">
                  <!-- Add New Coupon button could go here if needed in the future -->
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-0">
            <div class="p-4">
              <h5 class="font-weight-bolder mb-0">Escoja un cupón para editar</h5>
            </div>
            <div class="table-responsive" v-if="renderTable">
              <table id="datatableCoupons" class="table table-flush">
                <thead class="thead-light">
                  <tr>
                    <th>Acciones</th>
                    <th>Id</th>
                    <th>Nombre</th>
                    <th>Habilitado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in getCoupons" :key="c.id">
                    <td>
                      <i
                        class="material-icons text-secondary position-relative text-lg edit-btn cursor-pointer"
                        :data-id="c.id"
                        >edit</i
                      >
                      <i
                        class="material-icons text-secondary position-relative text-lg delete-btn cursor-pointer ms-3"
                        :data-id="c.id"
                        >delete</i
                      >
                    </td>
                    <td>{{ c.id }}</td>
                    <td>{{ c.name }}</td>
                    <td>{{ c.enabled ? "Sí" : "No" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      :id="'mantCoupon'"
      :body="'Editar Cupón'"
      dialogType="Dialog"
      :show="modalConfirmation"
      @close="toggleConfirmationModal"
      @save="onUpdateCoupon"
    >
      <div class="row mt-3">
        <div class="col-12 col-sm-4 mt-3 mt-sm-0">
          <material-input
            id="name"
            v-model="coupon.name"
            label="Nombre"
            variant="dynamic"
            :isRequired="true"
            :class="'is-focused'"
          />
        </div>
        <div class="col-12 col-sm-8 mt-3 mt-sm-0">
          <material-input
            id="generalDiscount"
            v-model="coupon.generalDiscount"
            label="Porcentaje descuento"
            variant="dynamic"
            :isRequired="true"
            :class="'is-focused'"
          />
        </div>
      </div>
      <div class="row mt-6">
        <div class="col-12 col-sm-4 mt-3 mt-sm-0">
          <material-input
            id="catExclusion"
            v-model="coupon.catExclusion"
            label="Exclusión de categoría"
            variant="dynamic"
            :isRequired="true"
            :class="'is-focused'"
          />
        </div>
        <div class="col-12 col-sm-4 mt-3 mt-sm-0">
          <material-checkbox
            v-model="coupon.onlyOnceUsage"
            :disabled="coupon.onlyOnceUsageStatus"
            >Uso único por usuario</material-checkbox
          >
        </div>
        <div class="col-12 col-sm-4 mt-3 mt-sm-0">
          <material-checkbox v-model="coupon.mandatoryFeature"
            >Cupón del sistema</material-checkbox
          >
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <material-checkbox v-model="coupon.enabled">Habilitado</material-checkbox>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DataTable } from "simple-datatables";
import Modal from "./components/Modal.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";

export default {
  name: "Cupones",
  components: {
    Modal,
    MaterialInput,
    MaterialCheckbox,
  },
  data() {
    return {
      renderTable: true,
      datatable: null,
      modalConfirmation: false,
      coupon: {
        id: 0,
        name: "",
        generalDiscount: 0,
        catExclusion: 0,
        onlyOnceUsage: false,
        onlyOnceUsageStatus: false,
        mandatoryFeature: false,
        enabled: true,
        originalCoupon: null,
      },
    };
  },
  computed: {
    ...mapGetters("business", ["getCoupons"]),
  },
  async mounted() {
    await this.getCouponsAction();
    this.$nextTick(() => {
      this.initDataTable();
    });
  },
  methods: {
    ...mapActions("business", {
      getCouponsAction: "getCoupons",
      updateCouponAction: "updateCoupon",
    }),
    initDataTable() {
      if (this.datatable) {
        this.datatable.destroy();
      }
      if (document.getElementById("datatableCoupons")) {
        this.datatable = new DataTable("#datatableCoupons", {
          searchable: true,
          fixedHeight: true,
        });

        this.datatable.dom.addEventListener("click", (event) => {
          const target = event.target;
          if (target.classList.contains("edit-btn")) {
            const id = target.dataset.id;
            this.prepareEdit(id);
          } else if (target.classList.contains("delete-btn")) {
            const id = target.dataset.id;
            this.onDelete(id);
          }
        });
      }
    },
    prepareEdit(id) {
      const coupon = this.getCoupons.find((c) => c.id == id);
      if (!coupon) return;

      this.coupon.originalCoupon = coupon;
      this.coupon.id = coupon.id;
      this.coupon.name = coupon.name;
      this.coupon.enabled = coupon.enabled;

      const generalDiscount = (coupon.couponData || []).find(
        (cd) => cd.couponTypeEnum == "GENERAL_DISCOUNT"
      );
      const categoryExclude = (coupon.couponData || []).find(
        (cd) => cd.couponTypeEnum == "CATEGORY_EXCLUDE"
      );
      const onlyOnceUsage = (coupon.couponData || []).find(
        (cd) => cd.couponTypeEnum == "ONLY_ONCE_USAGE"
      );
      const mandatoryFeature = (coupon.couponData || []).find(
        (cd) => cd.couponTypeEnum == "MANDATORY_FEATURE"
      );

      this.coupon.generalDiscount = generalDiscount ? generalDiscount.amount : 0;
      this.coupon.catExclusion = categoryExclude ? categoryExclude.amount : 0;
      this.coupon.onlyOnceUsage = onlyOnceUsage
        ? onlyOnceUsage.amount
          ? true
          : false
        : false;
      this.coupon.mandatoryFeature = mandatoryFeature
        ? mandatoryFeature.amount
          ? true
          : false
        : false;
      this.coupon.onlyOnceUsageStatus = this.coupon.mandatoryFeature;

      this.toggleConfirmationModal();
    },
    toggleConfirmationModal() {
      this.modalConfirmation = !this.modalConfirmation;
    },
    async onUpdateCoupon() {
      // Reconstruct couponData list
      const couponData = [];

      couponData.push({
        amount: parseInt(this.coupon.generalDiscount),
        couponTypeEnum: "GENERAL_DISCOUNT",
        fieldConstraint: null,
        valueConstraint: null,
      });

      if (this.coupon.catExclusion > 0) {
        couponData.push({
          amount: parseInt(this.coupon.catExclusion),
          couponTypeEnum: "CATEGORY_EXCLUDE",
          fieldConstraint: null,
          valueConstraint: null,
        });
      }

      if (this.coupon.onlyOnceUsage) {
        couponData.push({
          amount: 1,
          couponTypeEnum: "ONLY_ONCE_USAGE",
          fieldConstraint: null,
          valueConstraint: null,
        });
      }

      if (this.coupon.mandatoryFeature) {
        couponData.push({
          amount: 1,
          couponTypeEnum: "MANDATORY_FEATURE",
          fieldConstraint: null,
          valueConstraint: null,
        });
      }

      const couponDTO = {
        id: this.coupon.id,
        name: this.coupon.name,
        enabled: this.coupon.enabled,
        couponData: couponData,
        createdAt: this.coupon.originalCoupon.createdAt,
      };

      try {
        this.renderTable = false;
        await this.updateCouponAction({ id: this.coupon.id, couponDTO });
        this.renderTable = true;
        this.$nextTick(() => {
          this.initDataTable();
        });
        this.$swal.fire("Success", "Cupón actualizado correctamente", "success");
        this.toggleConfirmationModal();
      } catch (error) {
        this.renderTable = true;
        this.$swal.fire("Error", "No se pudo actualizar el cupón", "error");
      }
    },
    onDelete() {
      this.$swal.fire(
        "Informativo",
        "Función de eliminar cupón no implementada en el backend todavía",
        "info"
      );
    },
  },
};
</script>
